<template>
  <div class="vrt-wrap">
    <div class="vrt-main-video" v-if="live.liveStatus == 3">
      <!-- 录播 -->
      <div id="playbackPanel"></div>
      <p id="countDown"></p>
    </div>
    <div class="vrt-main-video" v-else>
      <!-- //直播 -->
      <div id="drawPanel"></div>
      <p id="countDown"></p>
      <div class="live-player-video">
        <video
          src="http://1300465694.vod2.myqcloud.com/b6e64ac0vodbj1300465694/2cca74e55285890811080024469/4r860cAun60A.mp4"
          id="livePlayerVideo"
          loop
          autoplay
          controls
          poster="https://beinabncc.oss-cn-beijing.aliyuncs.com/bncc/news/tu20201208.jpg"
        ></video>
      </div>
    </div>
    <div class="vrt-main-content">
      <div class="vrt-main-warp">
        <div class="vrt-tab-warp">
          <div class="vrt-main-tab">
            <ul>
              <li
                :class="{ current: itemBool == index, 'current-view': index == 1 }"
                v-for="(item, index) in menu"
                :key="index"
                @click="selectMenu(item)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="vrt-main-tab-content">
            <div class="vrt-main-tab-first" v-show="itemBool == 0">
              <div class="video-info">
                <template v-if="live.liveStatus == 0">
                  <div
                    class="count_down count_down_time"
                    v-if="intro.liveStartTime"
                    id="dateShow"
                  >
                    <p>直播倒计时</p>
                    <span class="d">07</span>天 <span class="h">22</span>小时
                    <span class="m">50</span>分 <span class="date-s s">56</span>秒
                  </div>
                  <div class="count_down">
                    <span>{{ intro.courseName && intro.courseName.substr(0, 38) }}</span>
                  </div>
                </template>
                <template v-if="live.liveStatus == 1">
                  <span class="count_down"><span>直播进行中</span></span>
                </template>
                <template v-if="live.liveStatus == 2">
                  <div class="count_down count_down_time" id="dateShow">
                    <p>直播倒计时</p>
                    <span class="d"></span>天 <span class="h"></span>小时
                    <span class="m"></span>分 <span class="date-s s"></span>秒
                  </div>
                </template>
                <template v-if="live.liveStatus == 3">
                  <span class="count_down live-end"><span>直播已结束</span></span>
                </template>
                <class-intro :intro="intro"></class-intro>
              </div>

              <div class="vrt-first-content">
                <div class="course-description">
                  <class-sch-card :courseChapterList="courseChapterList"></class-sch-card>
                </div>
              </div>
            </div>
            <div class="vrt-main-tab-second" v-show="itemBool == 1">
              <div class="vrt-talk-list">
                <div class="vrt-talk-list-ul vrt-second-list">
                  <ul>
                    <li>
                      <div class="vrt-talk-logo">
                        <img
                          src="https://shijiaoke.oss-cn-beijing.aliyuncs.com/public/picman.jpg?x-oss-process=image/resize,w_200"
                          alt="国家标准物质网网站地图，北京北纳创联技术研究院，课堂"
                        />
                      </div>
                      <div class="vrt-talk-box">
                        <p class="vrt-talk-info">
                          <span class="talk-vip">讲师</span>
                          <span class="talk-name">讲师</span>
                        </p>
                        <div class="vrt-talk-txt">
                          <p class="vrt-talk-main">您好，请问有什么可以为您解答的？</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vrt-talk-input-wrap">
                <div class="vrt-input-content">
                  <span class="vrt-input-icon gifticon" @click.stop="openGifticon"></span>
                  <div class="vrt-talk-input-main">
                    <textarea
                      type="text"
                      class="talk-input js-talk-input"
                      maxlength="200"
                      placeholder="我也来参与一下互动..."
                      id="chatipt"
                    ></textarea>
                    <span
                      class="vrt-input-icon faceicon"
                      @click.stop="openFaceicon"
                      id="btn-face"
                    ></span>
                  </div>
                  <span class="vrt-action-img">
                    <input
                      type="file"
                      id="action-img-btn"
                      accept="image/jpeg,image/jpg,image/png,image/gif"
                    />
                  </span>
                  <span class="vrt-input-icon imgicon"></span>
                  <span class="talk-send-btn" id="chatlistbtn" for="all">发送</span>
                </div>
                <div class="vrt-gift-wrap">
                  <div class="vrt-gift-main">
                    <ul>
                      <li
                        data-name="鲜花"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/01-flower.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/01-flower.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">鲜花</div>
                      </li>
                      <li
                        data-name="咖啡"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/02-coffee.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/02-coffee.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">咖啡</div>
                      </li>
                      <li
                        data-name="点赞"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/03-good.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/03-good.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">点赞</div>
                      </li>
                      <li
                        data-name="掌声"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/04-applaud.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/04-applaud.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">掌声</div>
                      </li>
                      <li
                        data-name="666"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/05-666.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/05-666.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">666</div>
                      </li>
                      <li
                        data-name="小星星"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/06-star.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/06-star.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">小星星</div>
                      </li>
                      <li
                        data-name="钻石"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/07-diamond.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/07-diamond.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">钻石</div>
                      </li>
                      <li
                        data-name="跑车"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/08-car.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/08-car.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">跑车</div>
                      </li>
                      <li
                        data-name="火箭"
                        data-pic="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/09-rocket.png"
                      >
                        <div class="course-gift-img">
                          <img
                            src="//livestatic.videocc.net/uploaded/images/webapp/channel/donate/09-rocket.png"
                            alt=""
                          />
                        </div>
                        <div class="course-gift-name">火箭</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="vrt-main-tab-third" v-show="itemBool == 2">
              <div class="vrt-talk-list">
                <div class="vrt-talk-list-ul vrt-quiz-list">
                  <ul>
                    <li>
                      <div class="vrt-talk-logo">
                        <img
                          src="https://shijiaoke.oss-cn-beijing.aliyuncs.com/public/picman.jpg?x-oss-process=image/resize,w_200"
                          alt="国家标准物质网网站地图，北京北纳创联生物技术研究院，课堂"
                        />
                      </div>
                      <div class="vrt-talk-box">
                        <p class="vrt-talk-info">
                          <span class="talk-vip">讲师</span>
                          <span class="talk-name">讲师</span>
                        </p>
                        <div class="vrt-talk-txt">
                          <p class="vrt-talk-main">您好，请问有什么可以为您解答的？</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vrt-talk-question-wrap vrt-talk-input-wrap">
                <div class="vrt-input-content">
                  <div class="vrt-talk-input-main">
                    <input
                      type="text"
                      class="talk-input js-talk-input"
                      placeholder="我想问讲师..."
                      id="chatipt_aq"
                    />
                  </div>
                  <span class="talk-send-btn" id="chatbtn">发送</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <input type="hidden" v-model="detail.nickname" id="username" />
  <template v-if="detail.isLive">
    <input type="hidden" v-model="detail.roomId" id="roomId" />
    <input type="hidden" v-model="detail.viewertoken" id="viewertoken" />
  </template>
  <template v-else>
    <input type="hidden" v-model="detail.liveId" id="liveId" />
    <input type="hidden" v-model="detail.recordRoomId" id="recordRoomId" />
    <input type="hidden" v-model="detail.recordId" id="recordId" />
    <input type="hidden" v-model="live.liveStatus" id="liveStatusId" />
    <input type="hidden" v-model="detail.viewertoken" id="viewertoken" />
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, nextTick, onUnmounted } from "vue";
import { useRoute } from "vue-router";

import dateFormat, { timeFormat } from "@/utils/dateFormat";
import ClassIntro from "@/components/common/ClassIntro.vue";
import ClassSchCard from "@/components/common/ClassSchCard.vue";
import api from "@/api/axios";
import $ from "jquery";
import asyncLoadJs, { removeJs } from "@/hooks/useAsyncLoadJs";
import leftTime, { clearTime } from "@/hooks/useLeftTime";

export default defineComponent({
  name: "videoRealtime",
  components: {
    ClassIntro,
    ClassSchCard,
  },
  setup() {
    const route = useRoute();
    const id = route.query.id;
    const type = route.query.type;
    const intro = ref({});
    const detail = ref({});
    const courseChapterList = ref<object>([]);
    const live = ref({});

    api
      .get("/M/Discover/VideoRealtime/" + id, {
        params: {
          type: type,
        },
      })
      .then((res) => {
        const data = res.data.obj;
        intro.value = data.course;
        detail.value = data;
        courseChapterList.value = data.courseChapterList;
        live.value = data.live;
        nextTick(() => {
          asyncLoadJs("js/jquery-3.1.1.min.js", "videoRealtime").then(() => {
            if (type == "0") {
              asyncLoadJs("js/playbackSDK.js", "videoRealtime").then(() => {
                asyncLoadJs("js/livePlayBack.js", "videoRealtime");
              });
            } else {
              asyncLoadJs("js/base.js", "videoRealtime").then(() => {
                asyncLoadJs("js/liveSDK.JS", "videoRealtime").then(() => {
                  asyncLoadJs("js/videoRealtime.js", "videoRealtime");
                });
              });
            }
          });
          leftTime(data.course.liveStartTime, function (d: any) {
            if (d.status) {
                const $dateShow1 = $("#dateShow");
                $dateShow1.find(".d").html(d.d);
                $dateShow1.find(".h").html(d.h);
                $dateShow1.find(".m").html(d.m);
                $dateShow1.find(".s").html(d.s);
            }
          })
        });
      })
      .catch((err) => {
        console.log(err);
      });

    function contrast(startDate: string) {
      return new Date().getTime() - new Date(timeFormat(startDate)).getTime() < 0
        ? true
        : false;
    }

    //  切换列表菜单
    const menu = ref(["直播介绍", "互动聊天", "提问"]);
    const itemBool = ref(0);
    function selectMenu(item: string) {
      if (item == "直播介绍") {
        itemBool.value = 0;
      }
      if (item.indexOf("互动聊天") != -1) {
        itemBool.value = 1;
      }
      if (item == "提问") {
        itemBool.value = 2;
      }
    }

    // const btnGiftIcon = ref(true);
    // const btnFace = ref(true);
    // function openGifticon() {
    //     if(btnGiftIcon.value){
    //         $(".vrt-talk-list").css({
    //             "paddingBottom": "204px"
    //         })
    //         $(".vrt-talk-list-ul ul").css({
    //             "paddingBottom": "5.6rem"
    //         })
    //         $(".vrt-talk-input-wrap").css({
    //             "bottom": "154px"
    //         })
    //         btnGiftIcon.value = false;
    //     }else{
    //         $(".vrt-talk-list").css({
    //             "paddingBottom": "50px"
    //         })
    //         $(".vrt-talk-list-ul ul").css({
    //             "paddingBottom": "1.867rem"
    //         })
    //         $(".vrt-talk-input-wrap").css({
    //             "bottom": "0"
    //         })
    //         btnGiftIcon.value = true;
    //     }
    // }

    // function openFaceicon() {
    //     if (btnFace.value) {
    //         btnFace.value = false;
    //         $('.embox').show()
    //     } else {
    //         btnFace.value = true;
    //         $('.embox').hide()
    //     }
    // }

    // onMounted(() => {
    //     const vrtHeight = document.body.clientWidth * 0.5625;
    //     $(".vrt-main-video").height(vrtHeight);
    //     $(document).bind('click', function () {
    //         btnFace.value = true;
    //         btnGiftIcon.value = true;
    //         $('.embox').hide()
    //         $(".vrt-talk-list").css({
    //             "paddingBottom": "50px"
    //         })
    //         $(".vrt-talk-list-ul ul").css({
    //             "paddingBottom": "1.867rem"
    //         })
    //         $(".vrt-talk-input-wrap").css({
    //             "bottom": "0"
    //         })
    //     })
    // })


    // onMounted(() => {
    //   nextTick(() => {
    //     asyncLoadJs("js/jquery-3.1.1.min.js").then(() => {
    //       if (type == "0") {
    //         asyncLoadJs("js/playbackSDK.js").then(() => {
    //           asyncLoadJs("js/livePlayBack.js");
    //         });
    //       } else {
    //         asyncLoadJs("js/base.js").then(() => {
    //           asyncLoadJs("js/liveSDK.JS").then(() => {
    //             asyncLoadJs("js/videoRealtime.js");
    //           });
    //         });
    //       }
    //     });
    //   });
    // });

    onUnmounted(() => {
      removeJs("jquery-3.1.1.min.js")
      removeJs("base.js")
      removeJs("liveSDK.JS")
      removeJs("videoRealtime.js")
      removeJs("playbackSDK.js")
      removeJs("livePlayBack.js");
      
      removeJs("socket.io.js")
      removeJs("swfobject.js")
      removeJs("json3.min.js")
      removeJs("report.js")
      removeJs("dpc.js")
    })

    return {
      contrast,
      intro,
      courseChapterList,
      live,
      menu,
      selectMenu,
      itemBool,
      detail,
      // openGifticon,
      // openFaceicon
    };
  },
});
</script>

<style src=".././assets/styles/videoRealtime.css"></style>

<style lang="scss" scoped>
  .author {
    padding-left: 62px;
  }
  #dateShow span {
    color: #df0024;
  }
</style>



